import React from 'react';
import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import ConfirmationNumberRoundedIcon from '@mui/icons-material/ConfirmationNumberRounded';

/* Each pill sends its prompt as if the user had typed it. The agent then asks
   for whatever is missing (dates, a colleague's name) and shows a card before
   anything is submitted, so a pill can never act on its own. The server
   answers these exact prompts without the model (assistant.quick.js), so
   change a prompt there too. */
export const SUGGESTIONS = [
    { label: 'Apply for leave', prompt: 'I want to apply for leave', Icon: EventAvailableRoundedIcon },
    { label: "Today's work report", prompt: 'Submit my work report for today', Icon: AssignmentTurnedInRoundedIcon },
    { label: 'Message a colleague', prompt: 'I want to send a message to a colleague', Icon: ChatBubbleOutlineRoundedIcon },
    { label: "This week's timesheet", prompt: 'Submit my timesheet for this week', Icon: ScheduleRoundedIcon },
    { label: 'Raise a ticket', prompt: 'I want to raise a help desk ticket', Icon: SupportAgentRoundedIcon },
    { label: 'My leave requests', prompt: 'Show my recent leave requests', Icon: HistoryRoundedIcon },
    { label: 'My tickets', prompt: 'Show my help desk tickets', Icon: ConfirmationNumberRoundedIcon },
];

/* `variant` is "grid" on the welcome screen and "row" (one scrollable line)
   above the input once the conversation has started. */
const AssistantSuggestions = ({ variant, disabled, onPick }) => (
    <div className={`assistant-pills is-${variant}`} role="group" aria-label="Suggestions">
        {SUGGESTIONS.map(({ label, prompt, Icon }, index) => (
            <button
                key={label}
                type="button"
                className="assistant-pill"
                style={{ '--i': index }}
                disabled={disabled}
                onClick={() => onPick(prompt)}
            >
                <Icon aria-hidden="true" />
                <span>{label}</span>
            </button>
        ))}
    </div>
);

export default AssistantSuggestions;
